import axios from 'axios';

/**
 * Fetches and caches user info
 * @param {boolean} forceRefresh - Force refresh even if data exists in session
 */
export const fetchAndCacheUserInfo = async (forceRefresh = false) => {
  const jwtToken = sessionStorage.getItem("jwtToken");

  if (!jwtToken) {
    console.error("JWT токен не найден");
    throw new Error("No JWT token");
  }

  // Если не форсируем обновление и данные уже есть - пропускаем запрос
  if (!forceRefresh && sessionStorage.getItem("balance")) {
    console.log("User data already cached, skipping fetch");
    return;
  }

  try {
    const response = await axios.post(
      "https://baaack.zabanishumresh.com/requestGetAllUserInfoWithTasks",
      {},
      {
        headers: {
          Authorization: `${jwtToken}`,
          "Content-Type": "application/json",
        },
      }
    );

    const userInfo = response.data;

    // Сохраняем все данные в sessionStorage
    sessionStorage.setItem("balance", userInfo.balance);
    sessionStorage.setItem("subscription_link", userInfo.subscription_link);
    sessionStorage.setItem("link_state", userInfo.link_state);
    sessionStorage.setItem("history_payments", userInfo.history_payments);
    sessionStorage.setItem("referral_link", userInfo.referral_link);
    sessionStorage.setItem("referrals", userInfo.referrals);
    sessionStorage.setItem("task", JSON.stringify([...userInfo.task]));

    // Очищаем старые тарифы
    sessionStorage.removeItem('subscription_link_basic');
    sessionStorage.removeItem('subscription_link_medium');
    sessionStorage.removeItem('subscription_link_premium');
    sessionStorage.removeItem('freeSubscriptionLink');
    sessionStorage.removeItem('tariff_expiry_basic');
    sessionStorage.removeItem('tariff_expiry_medium');
    sessionStorage.removeItem('tariff_expiry_premium');
    sessionStorage.removeItem('tariff_expiry_free');

    // Обрабатываем платные тарифы
    if (userInfo.unique_tariffs) {
      userInfo.unique_tariffs.forEach(tariff => {
        const nameLower = tariff.name.toLowerCase();
        if (nameLower.includes("basic")) {
          sessionStorage.setItem("subscription_link_basic", tariff.subscription_link);
          sessionStorage.setItem("tariff_expiry_basic", tariff.expiry);
        } else if (nameLower.includes("medium")) {
          sessionStorage.setItem("subscription_link_medium", tariff.subscription_link);
          sessionStorage.setItem("tariff_expiry_medium", tariff.expiry);
        } else if (nameLower.includes("premium")) {
          sessionStorage.setItem("subscription_link_premium", tariff.subscription_link);
          sessionStorage.setItem("tariff_expiry_premium", tariff.expiry);
        }
      });
    }

    // Обрабатываем бесплатный тариф
    if (userInfo.free_tariff && userInfo.free_tariff !== "0") {
      try {
        const parsedFreeTariff = JSON.parse(userInfo.free_tariff);
        if (parsedFreeTariff.subscription_link) {
          sessionStorage.setItem("free_subscription_link", parsedFreeTariff.subscription_link);
        }
        if (parsedFreeTariff.tariff_left) {
          const parts = parsedFreeTariff.tariff_left.split(' ');
          const daysLeft = parseInt(parts[0], 10) || 0;
          const hoursLeft = parseInt(parts[2], 10) || 0;
          const expiryTimestamp = Math.floor(Date.now() / 1000) + (daysLeft * 86400) + (hoursLeft * 3600);
          sessionStorage.setItem("tariff_expiry_free", expiryTimestamp.toString());
        }
      } catch (error) {
        console.error("Error parsing free tariff:", error);
      }
    }

    // Сохраняем all_tariffs
    const tariffsData = {
      basic: {
        link: sessionStorage.getItem('subscription_link_basic'),
        expiry: sessionStorage.getItem('tariff_expiry_basic')
      },
      medium: {
        link: sessionStorage.getItem('subscription_link_medium'),
        expiry: sessionStorage.getItem('tariff_expiry_medium')
      },
      premium: {
        link: sessionStorage.getItem('subscription_link_premium'),
        expiry: sessionStorage.getItem('tariff_expiry_premium')
      },
      free: {
        link: sessionStorage.getItem('free_subscription_link'),
        expiry: sessionStorage.getItem('tariff_expiry_free')
      }
    };

    sessionStorage.setItem('all_tariffs', JSON.stringify(tariffsData));
    sessionStorage.setItem("tarifsLoaded", "true");
    sessionStorage.setItem("tarifsLoadedTime", Date.now().toString());

    console.log("User info successfully cached");
    return userInfo;

  } catch (error) {
    console.error("Ошибка при запросе информации о пользователе:", error);
    throw error;
  }
};